// 登录
const o_login = () => {
  try {
    window.webkit.messageHandlers.isnotlogin.postMessage('login');
  } catch (e) {
    console.log('ios调用登录失败');
  }
  try {
    window.LiveAppJS.login();
  } catch (e) {
    console.log('安卓调用登录失败');
  }
  return '登录结束'
}
// 修改两端标题
const o_changeTitle = (title) => {
  try {
    window.webkit.messageHandlers.changeTitle.postMessage(title);
  } catch (e) {
    console.log('ios修改标题失败,标题为:', title);
  }
  try {
    window.LiveAppJS.changeTitle(title);
  } catch (e) {
    console.log('安卓修改标题失败,标题为:', title);
  }
  return title
}
// 修改状态栏颜色
const o_changeStatus = (bg, word) => {
  var iosParam = {
    "bgcolor": bg,
    "wordcolor": word
  };
  try {
    window.webkit.messageHandlers.changeStatusbar.postMessage(iosParam);
  } catch (e) {
    console.log('ios修改状态栏颜色失败', iosParam);
  }

  try {
    window.LiveAppJS.changeStatusbar(bg, word);
  } catch (e) {
    console.log('安卓修改状态栏颜色失败', bg, word);
  }
  return iosParam
}
// 打开新容器
const o_jumpweb = (androidParam,iosParam) => {
  try {
    window.webkit.messageHandlers.jumpWeb.postMessage(iosParam)
  } catch (e) {
    console.log('IOS跳转失败', iosParam)
  }
  try {
    window.LiveAppJS.jumpWeb(JSON.stringify(androidParam))
  } catch (e) {
    console.log('安卓跳转失败', androidParam)
  }
  return
}
// 关闭容器
const o_closeLayer = () => {
  var params = 'close'
  try {
    window.webkit.messageHandlers.closeLayer.postMessage(params)
  } catch (e) {
    console.log('ios关闭失败')
  }
  try {
    window.LiveAppJS.closeLayer(params)
  } catch (e) {
    console.log('Android关闭失败')
  }
}
// 分享--按钮在H5页面
const o_shareBtnInH5 = (title, desc, imgUrl, jumpUrl) => {
  let params = {
    title: title,
    des: desc,
    imageUrl: imgUrl,
    jumpUrl: jumpUrl
  };

  try {
    window.webkit.messageHandlers.share.postMessage(params)
  } catch (e) {
    console.log('ios调用分享失败', params)
  }
  try {
    window.LiveAppJS.share(title, imgUrl, jumpUrl, desc)
  } catch (e) {
    console.log(
      'Android调用分享失败', title, imgUrl, jumpUrl, desc
    )
  }
}
// 分享--分享按钮在app内
const o_shareBtnInApp = (title, desc, imgurl, jumpUrl) => {
  let params = {
    title: title,
    des: desc,
    imageUrl: imgurl,
    jumpUrl: jumpUrl
  };
  try {
    window.webkit.messageHandlers.shareProduct.postMessage(params);
  } catch (e) {
    console.log("ios启用分享按钮", params);
  }
  try {
    window.LiveAppJS.shareProduct(title, desc, imgurl, jumpUrl);
  } catch (e) {
    console.log("Android启用分享按钮", title, desc, imgurl, jumpUrl);
  }
}
// 打开播币充值弹窗(安卓)
const o_openBobiDialog = () => {
  try {
    window.LiveAppJS.recharge();
  } catch (e) {
    console.log('安卓打开充值弹窗失败')
  }
}
// 跳转播币充值页面
const o_openBobiPage = () => {
  try {
    window.webkit.messageHandlers.recharge.postMessage('recharge');
  } catch (e) {
    console.log('ios跳转充值页面失败')
  }
  try {
    window.LiveAppJS.startRecharge();
  } catch (e) {
    console.log('安卓跳转重新页面失败')
  }
}
// 商品购买/卡包购买拉起支付
const o_productBuy = (params) => {
  try {
    window.LiveAppJS.shoppingMallBuy(JSON.stringify(params))
  } catch (e) {
    window.console.log('Android拉起支付失败')
  }
  try {
    window.webkit.messageHandlers.shoppingMallBuy.postMessage(JSON.stringify(params))
  } catch (e) {
    window.console.log('ios拉起支付失败')
  }

}
// 会员购买
const o_buyVip = (params)=>{

}
// 连续包月
const o_autoRenew=(params)=>{
  
}
// 拨打电话
const o_callPhone=(params)=>{
  try {
    window.webkit.messageHandlers.phone.postMessage(params)
  } catch (e) {
    window.console.log('ios拨打电话失败', params)
  }
  try {
    window.LiveAppJS.phone(params)
  } catch (e) {
    window.console.log('Android拨打电话失败', params)
  }
}
module.exports = {
  o_login,
  o_changeTitle,
  o_changeStatus,
  o_jumpweb,
  o_closeLayer,
  o_shareBtnInH5,
  o_shareBtnInApp,
  o_openBobiDialog,
  o_openBobiPage,
  o_productBuy,
  o_callPhone
}